<template lang="pug">
	
	.badass-origins
		.background-image
			img(src="assets/images/badass-origins-intro.jpg")

		badass-origins-intro.badass-origins__section
		albums-slider.badass-origins__section
		badass-album.badass-origins__section
		black-beetles.badass-origins__section
		likeme-clip.badass-origins__section
		
</template>

<script>
		
	import Vue from 'vue'
	import Component from 'vue-class-component'
	import $ from 'jquery'
	import { TweenMax } from 'gsap'
	import Scroller from '../../utils/scroller.js'
	import Ticker from '../../utils/ticker.js'
	import * as PIXI from 'pixi.js'

	import BadassOriginsIntro from './_components/badass-origins-intro.vue'
	import AlbumsSlider from './_components/albums-slider.vue'
	import BadassAlbum from './_components/badass-album.vue'
	import BlackBeetles from './_components/black-beetles.vue'
	import LikemeClip from './_components/likeme-clip.vue'
	import Background from '../../components/background.vue'


	import Scrollable from '~abstracts/scrollable'

  	@Component({
		name: 'Youth',
		components: { Background,BadassOriginsIntro,AlbumsSlider,BadassAlbum,BlackBeetles,LikemeClip  }
	})

	class Youth extends Scrollable {


		mounted () {
			super.mounted()

			this._dom()
		}

		init () {
			super.init()

		}

		_bind () {
			super._bind()
		}

		_dom () {
			this.$bg = this.$el.querySelector('.background-image')
			this.$intro = this.$el.querySelector('.badass-origins-intro')
			this.$slider = this.$el.querySelector('.albums-slider')
		}

		initTimeline () {
			super.initTimeline()

			const windowRatio = window.innerHeight / this.totalHeight

			this.tl.fromTo(this.$bg,1,{y:0},{y: this.totalHeight,ease:Power0.easeNone},0)
			this.tl.fromTo(this.$bg,windowRatio,{opacity:1},{opacity: 0,ease:Power0.easeNone},1 - windowRatio)
		}

		raf (y) {
			super.raf(y)	
		}

		_resize () {
			super._resize()

			this.totalHeight = this.$intro.getBoundingClientRect().height + this.$slider.getBoundingClientRect().height

			this.boundsAnim = {
				top: this.bounds.top,
				bottom: this.bounds.top + this.totalHeight
			}

			this.initTimeline()
		}

		_on () {
			super._on()
		}

		_off () {
			super._off()
			
		}

	}

	export default Youth

</script>


<style lang="stylus">
	
	@import '../../theme/utils'
	@import '../../theme/variables'
	
	.badass-origins
		width 100%
		background #0f0d37
		position relative
		overflow hidden


		.background-image
			position absolute
			top 0
			left 0
			width 100%
			height 100vh
			// will-change transform
			z-index 40

			img
				height 100%
				width 100%
				object-fit cover
				position relative
				z-index 40

		&__section
			position relative
			z-index 60

	
</style>


// WEBPACK FOOTER //
// badass-origins.vue?62077092